/* eslint-disable no-restricted-globals */
import { initializeApp } from 'firebase/app'
// import { getMessaging } from 'firebase/messaging/sw'
import { getToken, getMessaging, deleteToken } from 'firebase/messaging'

// import firebase from 'firebase/app';
// import 'firebase/messaging';
const vapidKey =
  'BGOKodZlT0JBTf5B_8UdPVy76RLRrC_nE3NXh92Nf7IRnn2OWAgIEBWe51SpEdOJIF5cL4wSfXhCCfVTJaru3Os'
var firebaseConfig = {
  apiKey: 'AIzaSyBOoIgClmROSlGtLqHsyclgyMmiYk_Ie74',
  authDomain: 'spotter-6f477.firebaseapp.com',
  projectId: 'spotter-6f477',
  storageBucket: 'spotter-6f477.appspot.com',
  messagingSenderId: '1094864283227',
  appId: '1:1094864283227:web:0474b4b965bcd326c5c17e',
  measurementId: 'G-WX2KGNXX11',
}

const config = {
  apiKey: firebaseConfig.apiKey,
  authDomain: firebaseConfig.authDomain,
  projectId: firebaseConfig.projectId,
  storageBucket: firebaseConfig.storageBucket,
  messagingSenderId: firebaseConfig.messagingSenderId,
  appId: firebaseConfig.appId,
}

const firebaseApp = initializeApp(config)
const messaging = getMessaging(firebaseApp)

export const requestFirebaseNotificationPermission = (saveToken) => {
  getToken(messaging, { vapidKey })
    .then((currentToken) => {
      saveToken(currentToken)
    })
    .catch((err) => {
      console.log('An error occurred while retrieving token. ', err)
    })
}


export const deleteFirebaseToken = () => {
  deleteToken(messaging)
}
